// src/services/apiService.ts
import { get, post, getBlob } from '@/api/request-lib';

export interface Data {
  id: number;
  name: string;
}

export interface CodeDiffMessage {
  fileItems: object;
  userMessage: string;
  cultureInfo: string;
  mode: string;
}

export enum StateEnum {
  Success = 0,
  OutOfToken = 1,
  UnknownError = 2,
}

export interface ClientData {
  /** 执行结果状态 */
  state: StateEnum;
  /** 错误信息 */
  errorMessage: string;
  /** 反馈的文件列表 */
  feedBackFiles: { [key: string]: string };
  /** 请求令牌 */
  requestToken: number;
  /** 响应令牌 */
  responseToken: number;
  /** 重试次数 */
  retryCount: number;
}

export const fetchData = async (): Promise<string> => {
  try {
    const data = await get<string>('/api/erdiagram/public');
    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
};

export const fetchProtectedData = async (accessToken: string): Promise<string> => {
  try {
    const data = await get<string>(
      '/api/erdiagram/protected',
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
};

export const fetchLatestERDiagramData = async (accessToken: string, cultureInfo: string): Promise<object> => {
  try {
    const data = await get<object>(
      `/api/classdiagram?t=${Date.now()}`,
      {
        cultureInfo,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
};

export const fetchUserInfo = async (accessToken: string): Promise<object> => {
  try {
    const data = await get<object>(
      `/api/classdiagram/profile?t=${Date.now()}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    throw error;
  }
};

// 添加post方法，url是/api/classdiagram/chat, 使用 Authorization: `Bearer ${accessToken}`
export const chatWithClassDiagram = async (payload: any, accessToken: string): Promise<any> => {
  try {
    const data = await post<any>('/api/classdiagram/chat', payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    console.error('Failed to chat with class diagram:', error);
    throw error;
  }
};

export const submitData = async (payload: Data): Promise<Data> => {
  try {
    const result = await post<Data>('/data', payload);
    return result;
  } catch (error) {
    console.error('Failed to submit data:', error);
    throw error;
  }
};

export const exportDocx = async (accessToken: string, cultureInfo: string, userName: string): Promise<object> => {
  try {
    const data = await getBlob(
      `/api/classdiagram/export?t=${Date.now()}`,
      {
        type: 'DOCX',
        cultureInfo,
        userName,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error('Failed to export data:', error);
    throw error;
  }
};

export const analysisAndModify = async (payload: CodeDiffMessage, accessToken: string): Promise<ClientData> => {
  try {
    const data = await post<ClientData>('/api/codediff/analysisAndModify', payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      timeout: 300000, // 设置为5分钟
    });
    return data;
  } catch (error) {
    console.error('Failed to analysis and modify:', error);
    throw error;
  }
};
